import React, { HTMLAttributes } from "react";
import { Heading } from "components/Heading";
import { cn } from "utils/helpers";
import { RfxQuestionSection } from "../../../types/returnable-schedule-question.type";

interface SectionComponentProps extends HTMLAttributes<HTMLDivElement> {
	className?: string;
	section: RfxQuestionSection;
	fieldValue?: any; // Keep as `any` or refine if you know its structure
	isSubmission?: boolean;
	hasError?: boolean;
}

export const SectionComponent: React.FC<SectionComponentProps> = ({
	className,
	section,
	fieldValue,
	isSubmission = false,
	hasError = false,
	...props
}) => {
	return (
		<>
			{isSubmission ? (
				<div className="space-y-2 border-b border-fg-senary-300 py-6">
					{hasError && (
						<span className="text-md !text-red-600">
							Please correct response errors below
						</span>
					)}
					<Heading
						className={`text-4xl ${hasError ? "!text-red-600" : "!text-royal-blue"}`}
					>
						{section.name}
					</Heading>
					<p className="whitespace-pre-line text-lg text-tertiary-600">
						{section.description}
					</p>
				</div>
			) : (
				<div
					className={cn("mt-6 min-h-14 border-b", className)}
					{...props}
				>
					<h1 className="text-xl font-bold">{section.name}</h1>
					<p>{section.description}</p>
				</div>
			)}
		</>
	);
};
